const translations = {
  "en": {
    "Turn on notifications in the app.": "Turn on notifications in the app."
  },
  "zh-tw": {
    "Turn on notifications in the app.": "請於App內開啟通知。"
  }
};

export default translations;
